import { useAuth } from "../../auth/AuthProvider";

export default function SubmitaReconciliactionPage() {
  // const { user } = useAuth(); // <--- Uncomment when auth state is ready

  return (
    <main className="dashboard-page page bg-white min-h-screen">
      <div className="max-w-7xl mx-auto py-12 px-4">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_10%] gap-12">
          
          {/* Quick Jump Section */}
          <div className="flex h-full flex-col rounded-[32px] border-2 border-white bg-white p-6 lg:items-center lg:p-8">
            <div className="w-full max-w-[1024px] sm:max-w-[500px] lg:max-w-[1440px]">
              <h2 className="text-2xl font-semibold mb-2 text-gray-700">
                ReconciliACTIONs and the Artist Ambassador Contest
              </h2>
              <p className="text-gray-500 mb-6">
                Submitting reconciliACTIONs throughout the school year offers you a chance to connect with DWF Artist Ambassadors.
              </p>
              <h3 className="text-1xl font-semibold mb-2 text-gray-700">
                How does it work?
              </h3>
                <p className="text-gray-500 mb-6">
                In the fall, winter, and spring, we'll publish a list of Artist Ambassador workshops. To enter, just submit your reconciliACTIONs. You can include pictures and describe the wonderful actions you're taking. Want to increase your chances? Submit more than one reconciliACTION! 
                 </p>
                 <h3 className="text-1xl font-semibold mb-2 text-gray-700">
                What do I win?
              </h3>
                <p className="text-gray-500 mb-6">
                A one-hour Artist Ambassador visit on Zoom. Four lucky classrooms get to join each session! And as a bonus — in June, we'll pick some classrooms to win DWF swag.
                 </p>
                 <h3 className="text-1xl font-semibold mb-2 text-gray-700">
                How do I select my Artist Ambassador visit?
              </h3>
                <p className="text-gray-500 mb-6">
                We'll notify you in The HUB and include a link to register for a session. It's first come, first serve, so make sure you log in often for your best chance to book the Artist Ambassador workshop and time that works for you.
                 </p>
                <p className="mb-6 hover:underline"> 
                  <a href="https://downiewenjack.ca/wp-content/uploads/2026/09/Contest_Rules_Artist-Ambassador-Visit-2026.pdf" target="_blank" rel="noopener noreferrer">
                    Read our Artist Ambassador Contest Rules for more information.
                </a>
                </p>

            </div>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              {/* External Link - Opens in a new tab */}
              <a 
                href="https://downiewenjack.ca/our-work/reconciliactions/#reconciliactionform" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-4 py-2 bg-[#4F2874] text-white rounded-lg hover:bg-[#381954] transition-colors"
              >
                Submit a ReconciliACTION to Win
              </a>
            </div>
          </div>
        </div>
      </div>    
    </main>
  );
}